import React from "react";

export default function NotFound() {
  return (
    <>
      <div className="main">
        <div>404</div>
      </div>
    </>
  );
}
